import { render, staticRenderFns } from "./DeliveryZoneList.vue?vue&type=template&id=22601298&scoped=true"
import script from "./DeliveryZoneList.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22601298",
  null
  
)

export default component.exports